import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Modal, Button, Tabs, Tab } from 'react-bootstrap';
import Calendar from 'react-calendar';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers, addUser, setUser } from '../actions/user';
import { addObjective, updateObjective } from '../actions/objective';
import Search from './Search/';
import { FormateDate, searchUsers, searchDependencies, stringToSlug, snapshotToArray } from '../helpers';
import ObjectiveValidation, { StatusValidation } from '../helpers/validation';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { fetchDependencies } from '../actions/dependency';
import DeleteObjective from "./DeleteObjective";
import Status from './AddActivity/status';

const TabOuter = styled.div`
						border:solid 1px #F5DADA;
						.react-calendar__tile--active {
							background: #F5DADA!important;
							color: white!important;
							border-radius: 50%;
							&:hover{
								background: #F5DADA;
							}
						}
						.react-calendar__month-view__weekdays{
							display:none!important;
						}
						.react-calendar__navigation {
							margin-bottom: 0px;
						}
						.react-calendar__tile {
							max-width: 100%;
							text-align: center;
							padding: 0.5em 0.5em;
						}
						.react-calendar__month-view{
							width:80%;
							margin:auto;
						}

`;

const SearchSuggestions = styled.div`
                        background:#E8E8E8;
                        border: 1px solid #ced4da;
                        border-top:0px;
						
						.search-selected{
                          	background:#fff;
                          	border-left: solid 1px #F5DADA;
							
							  ul{
								li{
									&:hover{
										color:#fff;
										background: #0184FE
									}
								}
							}
                        }
                        ul{
							list-style-type:none;
							margin:0px;
							padding:0px;

							li{
								padding: 5px 15px;
							}
                        }
`;

const _getObjectiveObject = () => {

    let objObj = {};

    objObj.name = '';
    objObj.status = 'scheduled';
    objObj.description = '';
    objObj.users = [];
    objObj.start = '';
    objObj.finish = '';
    objObj.last_updated = new Date();

    return objObj;
}


const CreateObjective = (props) => {

    const [objective, setObjective] = useState(props.item ? props.item : _getObjectiveObject());
    const [errors, setErrors] = useState([]);

    const users = useSelector(state => state.users);
    const currentUser = useSelector(state => state.currentUser);
    const activities = useSelector(state => state.activities);

    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const handleDelete = () => setShowDelete(false);

    const deleteItem = function (event) {
        event.preventDefault();
        setShowDelete(true);
    };

    const dispatch = useDispatch();

    useEffect(() => {
        if (props.item) {
            setObjective(props.item);
        }
    }, [activities]);

    useEffect(() => {
        if (props.item) {
            setObjective(props.item);
        }
    }, [props.item]);

    useEffect(() => {
        dispatch(fetchDependencies());
    }, []);

    const handleDeleteShow = function (event) {
        event.preventDefault();
        setShowDelete(true);
    };

    const updateUsers = (users) => {

        setObjective({
            ...objective,
            users: users
        });

    }

    const setStart = (date) => {
        setObjective({
            ...objective,
            start: FormateDate(date)
        });
    }

    const setFinish = (date) => {
        setObjective({
            ...objective,
            finish: FormateDate(date)
        });
    }

    const createObjective = () => {
        let _validation = ObjectiveValidation(objective);
        if (ObjectiveValidation(objective).length > 0) {
            setErrors(ObjectiveValidation(objective));

            setTimeout(function () {
                setErrors([]);
            }, 5000);
            return;
        }

        dispatch(addObjective(objective));

        setObjective(_getObjectiveObject());
        props.onHide();
    }

    const _updateObjective = () => {
        let _validation = ObjectiveValidation(objective);

        // if (activity.status === 'completed') {
        //     if (!StatusValidation(activity, dependencies)) {
        //         _validation.unshift("Dependencies must be completed to mark as complete");
        //     }
        // }

        if (_validation.length > 0) {

            setErrors(_validation);

            setTimeout(function () {
                setErrors([]);
            }, 5000);
            return;
        }

        // activity.last_updated = new Date().toString();
        dispatch(updateObjective(objective));
        props.onHide();
        setShowEdit(false);

    }

    const updateTitle = (event) => {
        setObjective({
            ...objective,
            name: event.target.value
        });
    }

    const updateDescription = (event) => {
        setObjective({
            ...objective,
            description: event.target.value
        });
    }

    const updateStatus = (value) => {

        setObjective({
            ...objective,
            status: value
        });
    }




    const getCurrentDate = () => {
        let date = new Date();

        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        return `${year}-${month}-${day}`;
    }

    const showEditMode = () => {
        setShowEdit(true);
    }

    return (

        <Modal show={props.show} onHide={props.onHide} id="activity-modal">

            <React.Fragment>
                <Modal.Header closeButton>
                    <Modal.Title>{props.item ? 'Edit Business Priority' : 'Post Business Priority'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-12 col-lg-7">
                            <form>
                                <div className="form-group">
                                    <input type="text" className="form-control" id="objectiveTitle" value={objective.name} placeholder="Business Priority Title"
                                        onChange={updateTitle} autoComplete="off" />
                                </div>
                                <div className="form-group">
                                    <small id="description" className="form-text text-muted">Describe your Business priority in more detail</small>
                                    <textarea className="form-control" id="activityDescription" rows="5" onKeyUp={updateDescription}
                                        value={objective.description} onChange={updateDescription}></textarea>
                                    <small id="descriptionWarning" className="form-text activity-warning">Information shared here will be available to all Arq employees</small>
                                </div>
                                <Search title="Tag Owner(s)" id="owners" data={users} onSelect={updateUsers} model={searchUsers}
                                    selected={props.item && props.item.users ? props.item.users : []} />
                            </form>
                        </div>
                        <div className="col-sm-12 col-lg-5">
                            <div className="row">
                                <div className="col-12">
                                    <TabOuter>
                                        <Tabs id="calendar-tabs">
                                            <Tab eventKey="start-date" title="Start date">
                                                <Calendar onChange={setStart} value={props.item && props.item.start ? new Date(props.item.start) : new Date(getCurrentDate())} />
                                            </Tab>
                                            <Tab eventKey="due-date" title="Due date">
                                                <Calendar onChange={setFinish} value={props.item && props.item.finish ? new Date(props.item.finish) : new Date(getCurrentDate())} />
                                            </Tab>
                                        </Tabs>
                                    </TabOuter>
                                </div>
                            </div>

                            {props.item && (currentUser.role && currentUser.role === 'admin') ?
                                <Status updateStatus={updateStatus} status={objective.status} />
                                : ''}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">

                            {errors && errors.length > 0 ?
                                <div className="alert alert-danger" role="alert">
                                    <ul>
                                        {errors.map((value, index) => (
                                            <li key={index}>{value}</li>
                                        )
                                        )}
                                    </ul>
                                </div>
                                : ''
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={props.item ? _updateObjective : createObjective}>
                        {props.item ? 'Update' : 'Save'}
                    </Button>
                    {props.item ?
                        <Button variant="btn btn-secondary" onClick={handleDeleteShow}>
                            Delete
						    </Button>
                        : ''}
                </Modal.Footer>
                {props.item ?
                    <DeleteObjective show={showDelete} onHide={handleDelete} item={props.item} deleteItem={deleteItem} />
                    : ''}
            </React.Fragment>

        </Modal>
    );
}

export default CreateObjective;
